// Bandas de color del nivel (probabilidad x severidad, 1-25) — misma paleta
// de 5 colores que .lvl1-.lvl5 en el prototipo de diseño (verde -> rojo).
export const LEVEL_BANDS = [
  { max: 5, color: "#2E9E5B", labelKey: "risk_matrix_level_very_low" },
  { max: 10, color: "#8DBF3F", labelKey: "risk_matrix_level_low" },
  { max: 15, color: "#F2C037", labelKey: "risk_matrix_level_medium" },
  { max: 20, color: "#E8893B", labelKey: "risk_matrix_level_high" },
  { max: 25, color: "#D6453D", labelKey: "risk_matrix_level_critical" },
];

export function getLevelColor(level) {
  const band = LEVEL_BANDS.find((b) => level <= b.max);
  return (band || LEVEL_BANDS[LEVEL_BANDS.length - 1]).color;
}
